<template>
  <v-btn
    :icon="displayField.citation?.deleted ? 'mdi-arrow-u-left-top' : 'mdi-open-in-new'"
    variant="text"
    class="citation-icon"
    @click="handleIconClick"
  />
</template>

<script lang="ts">
import {PropType} from 'vue';
import {DisplayField} from '@/lib/classes/InfoWindowContent';

export default {
  name: 'CitationIcon',
  props: {
    displayField: {
      type: Object as PropType<DisplayField>,
      required: true,
    },
  },
  methods: {
    handleIconClick() {
      if (!this.displayField.citation) return;

      if (!this.displayField.citation.deleted) {
        this.displayField.citation.openCitation();
      } else {
        this.displayField.citation.restoreCitation();
      }
    },
  },
};
</script>

<style scoped lang="scss">
// Pin the citation icon to the same footprint the previous IconButton (size="x-small")
// gave it: a tight 26x26 box with a 16px glyph. SlottedRow lays this out in a 17px-wide
// column (.displayLabelIcon), so a default-sized Vuetify icon button overflows onto the
// value input and inflates the row height. Keeping these fixed prevents that overlap and
// the focus-time layout shift.
.citation-icon {
  width: 26px;
  height: 26px;
  min-width: 26px;

  :deep(.v-icon) {
    font-size: 16px;
  }
}
</style>
